// Function to add "(Opens in a new tab)" to links with target="_blank"
export default () => {
	// Get all links on the page
	const links = document.querySelectorAll('a[target="_blank"]');

	// Loop through each link and append the notice
	links.forEach(function (link) {
		// Check if the notice is not already added to prevent duplicates
		if (!link.textContent.includes('(Opens in a new tab)')) {
			link.textContent += ' (Opens in a new tab)';
		}
	});
};
